__turbopack_context__.v({
  "className": "outfit_79c3bd89-module__K1U91a__className",
  "variable": "outfit_79c3bd89-module__K1U91a__variable",
});
